import { showNotification } from '@mantine/notifications';
import { isAxiosError } from 'axios';
import type { ErrorResponse } from '@/types/error';

export const getApiErrorMessage = ({ error, fallback }: { error: unknown; fallback: string }): string => {
  if (!error) {
    return fallback;
  }

  if (!isAxiosError<ErrorResponse>(error)) {
    return error instanceof Error && error.message.trim() ? error.message : fallback;
  }

  const errorResponse = error.response?.data;
  if (!errorResponse) {
    return fallback;
  }

  const messages: string[] = [];

  const topLevelMessage = errorResponse.message?.trim();
  if (topLevelMessage) {
    messages.push(topLevelMessage);
  }

  const fieldMessages = (errorResponse.errors ?? [])
    .flatMap((fieldError) => fieldError.messages)
    .map((message) => message.trim())
    .filter(Boolean);

  for (const fieldMessage of fieldMessages) {
    if (!messages.includes(fieldMessage)) {
      messages.push(fieldMessage);
    }
  }

  if (messages.length === 0) {
    return fallback;
  }

  return messages.join('. ');
};

export const showError = (e: unknown) => {
  showNotification({
    title: 'Error',
    message: e instanceof Error ? e?.message : String(e),
    color: 'red',
    autoClose: 4000,
  });
};
